import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import esCommon from './locales/es/common.json'
import esNav from './locales/es/nav.json'
import esEngineering from './locales/es/engineering.json'
import esPurchases from './locales/es/purchases.json'
import esCrm from './locales/es/crm.json'
import esOperations from './locales/es/operations.json'
import esClevel from './locales/es/clevel.json'
import esSettings from './locales/es/settings.json'
import esAdmin from './locales/es/admin.json'
import esPersonas from './locales/es/personas.json'
import esComercial from './locales/es/comercial.json'
import esCompras from './locales/es/compras.json'

import enCommon from './locales/en/common.json'
import enNav from './locales/en/nav.json'
import enEngineering from './locales/en/engineering.json'
import enPurchases from './locales/en/purchases.json'
import enCrm from './locales/en/crm.json'
import enOperations from './locales/en/operations.json'
import enClevel from './locales/en/clevel.json'
import enSettings from './locales/en/settings.json'
import enAdmin from './locales/en/admin.json'
import enPersonas from './locales/en/personas.json'
import enComercial from './locales/en/comercial.json'
import enCompras from './locales/en/compras.json'

const resources = {
  es: {
    common: esCommon, nav: esNav, engineering: esEngineering, purchases: esPurchases,
    crm: esCrm, operations: esOperations, clevel: esClevel, settings: esSettings, admin: esAdmin,
    personas: esPersonas, comercial: esComercial, compras: esCompras,
  },
  en: {
    common: enCommon, nav: enNav, engineering: enEngineering, purchases: enPurchases,
    crm: enCrm, operations: enOperations, clevel: enClevel, settings: enSettings, admin: enAdmin,
    personas: enPersonas, comercial: enComercial, compras: enCompras,
  },
}

const NS = ['common', 'nav', 'engineering', 'purchases', 'crm', 'operations', 'clevel', 'settings', 'admin', 'personas', 'comercial', 'compras']

const stored = (typeof localStorage !== 'undefined' && localStorage.getItem('lang')) || 'es'
const initialLng = ['es', 'en'].includes(stored) ? stored : 'es'

i18n.use(initReactI18next).init({
  resources,
  lng: initialLng,
  fallbackLng: 'es',
  supportedLngs: ['es', 'en'],
  ns: NS,
  defaultNS: 'common',
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
})

if (typeof document !== 'undefined') {
  document.documentElement.lang = initialLng
}

export async function setLanguage(lng) {
  const next = ['es', 'en'].includes(lng) ? lng : 'es'
  await i18n.changeLanguage(next)
  try { localStorage.setItem('lang', next) } catch { /* ignore */ }
  if (typeof document !== 'undefined') document.documentElement.lang = next
}

// Locale string for Intl/toLocaleDateString. es -> es-CL, en -> en-US.
const LOCALE_MAP = { es: 'es-CL', en: 'en-US' }
export function currentLocale() {
  return LOCALE_MAP[i18n.language] ?? 'es-CL'
}

export default i18n
